"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformSource = void 0;
function transformSource(source) {
  return source.replace(/(!\[[^\]]*\]\([^)\s]+) =([0-9]+x|x[0-9]+|[0-9]+x[0-9]+)\)/g, '$1_33B2BF251EFD_$2)');
}
exports.transformSource = transformSource;